import Navbar from '@/components/feature/Navbar';
import { useThemeStore } from '@/stores/themeStore';

const PreferencesPage = () => {
  const mode = useThemeStore((state) => state.mode);
  const setTheme = useThemeStore((state) => state.setTheme);

  return (
    <div className="min-h-screen bg-[#0A0A0F] text-white">
      <Navbar />
      <main className="mx-auto max-w-4xl px-6 pb-16 pt-24 md:px-10">
        <h1 className="mb-8 text-2xl font-semibold" style={{ fontFamily: "'Playfair Display', serif" }}>
          Preferências
        </h1>
        <section className="flex flex-col gap-5 border-y border-white/10 py-6 sm:flex-row sm:items-center sm:justify-between">
          <h2 className="text-sm font-medium text-white/80">Aparência das cifras</h2>
          <div role="group" aria-label="Aparência das cifras" className="flex w-full max-w-xs rounded-lg border border-white/15 bg-white/5 p-1 sm:w-auto">
            {(['dark', 'light'] as const).map((option) => (
              <button
                key={option}
                type="button"
                aria-pressed={mode === option}
                onClick={() => setTheme(option)}
                className={`flex h-10 flex-1 items-center justify-center gap-2 rounded-md px-4 text-sm transition-colors sm:flex-none ${
                  mode === option ? 'bg-[#C8A96E]/20 text-[#E6C98B]' : 'text-white/55 hover:text-white'
                }`}
              >
                <i className={`ri-${option === 'dark' ? 'moon' : 'sun'}-line`} aria-hidden="true" />
                {option === 'dark' ? 'Escuro' : 'Claro'}
              </button>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
};

export default PreferencesPage;